import { NgModule } from '@angular/core';
import {APP_BASE_HREF} from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

// import { userResolverFn } from '@app/core/services/resolver';
import { NotFoundComponent } from './not-found/not-found.component';


export const routes: Routes = [
  {
    path: 'receptacle',
    loadChildren: () => import('@app/collector/collector.module').then(m => m.CollectorModule),
    // resolve: {
    //   user: userResolverFn
    // }
  },
  { path: '404', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule],
  providers: [{provide: APP_BASE_HREF, useValue : '/' }]
})
export class AppRoutingModule { }
